module.exports = __webpack_public_path__ + "img/KSC09530.d23570af.jpg";